'use client';
import { List as SharedList } from '@launchstore/shared-puck';
import type { ListProps } from '@launchstore/shared-puck';
export const List: any = SharedList;
export type { ListProps };
export default List;
